// Compact display for view/like counters: 950 -> "950", 1500 -> "1.5k", 15000 -> "15k", 1200000 -> "1.2M"
const formatCount = (n) => {
  const num = Number(n) || 0;
  if (num < 1000) return String(num);
  if (num < 1000000) {
    const v = num / 1000;
    return `${v >= 100 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}k`;
  }
  const v = num / 1000000;
  return `${v >= 100 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}M`;
};

export default formatCount;
